<template>
  <div class="d-none d-lg-block">
    <b-collapse class="bg-morado-claro" id="filtros-pantalla" v-model="show">
      <b-row class="pt-4 pb-2 px-3 mx-0">
        <b-col
          v-for="(valor, llave, index) in filtrosPorTipo"
          class="text-azul"
          :class="{ 'pb-3': index === 0 }"
          :key="'dropdown-filtros-desktop-' + llave"
        >
          <b-dropdown
            class="w-100"
            toggle-class="btn-azul-outline"
            variant="outline"
            :id="'dropdown-filtros-' + llave"
            :data-testid="'dropdown-filtros-' + llave"
          >
            <template slot="button-content">
              <FontAwesomeIcon
                v-if="valor.showIcon"
                class="mr-2"
                :icon="valor.imagen"
              ></FontAwesomeIcon>
              <span v-else class="mr-2 font-weight-bold text-morado-claro">{{
                valor.imagen
              }}</span>
              {{ traducirCategorias(llave) }}
            </template>
            <b-dropdown-form>
              <b-form-checkbox-group
                :id="'desktop-filtros-' + llave"
                :name="'desktop-filtros-' + llave"
                v-model="form[valor.valor]"
                v-if="valor.checkbox"
              >
                <b-form-checkbox
                  v-for="filtro in valor.filtros"
                  :key="'desktop-filtro-' + llave + '-' + filtro"
                  :id="'desktop-filtro-' + llave + '-' + filtro"
                  :name="'desktop-filtro-' + llave + '-' + filtro"
                  :data-testid="'desktop-filtro-' + llave + '-' + filtro"
                  :value="filtro"
                >
                  {{ traducirFiltros(filtro) }}
                </b-form-checkbox>
              </b-form-checkbox-group>
              <b-form-checkbox-group
                :id="'desktop-filtros-' + llave"
                :name="'desktop-filtros-' + llave"
                v-else
              >
                <b-form-radio
                  v-for="filtro in valor.filtros"
                  v-model="form[valor.valor]"
                  :key="'desktop-filtro-' + llave + '-' + filtro"
                  :id="'desktop-filtro-' + llave + '-' + filtro"
                  :name="'desktop-filtro-' + llave + '-' + filtro"
                  :data-testid="'desktop-filtro-' + llave + '-' + filtro"
                  :value="filtro"
                >
                  {{ traducirFiltros(filtro) }}
                </b-form-radio>
              </b-form-checkbox-group>
              <b-dropdown-divider />

              <b-dropdown-item-button
                type="submit"
                class="btn-outline btn-azul-outline mt-3 w-100 rounded text-center"
                :id="'desktop-aplicar-filtros-' + llave"
                :data-testid="'desktop-aplicar-filtros-' + llave"
                @click.prevent="
                  aplicarFiltros(
                    [...form[valor.valor]],
                    llave,
                    'dropdown-filtros-' + llave
                  )
                "
              >
                Filtrar
              </b-dropdown-item-button>
            </b-dropdown-form>
          </b-dropdown>
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
import Filtros from "@/utils/Filtros";
import MixinFiltros from "@/mixins/filtros";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChalkboardTeacher,
  faClock,
  faFilter,
  faRestroom
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faChalkboardTeacher, faClock, faFilter, faRestroom);
export default {
  //props
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  mixins: [MixinFiltros],
  //components
  components: {
    FontAwesomeIcon
  }
  //data
};
</script>



// WEBPACK FOOTER //
// src/components/busqueda/filtros/FiltrosDesktop.vue